import { SearchedKeywordDetailModel } from './searched.keyword.detail.model';

export class PagedSearchedKeywordDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: SearchedKeywordDetailModel[] = [];
}
